export const TitleEdit = ({record, title, source}) => {
  return <span>{title} {(source && record[source]) ? record[source] : ''}</span>;
};
